/* EVENTS INVOLVING ACCOUNTS  */

function getDefaultAccountDashboardProps({ dashboard }) {
    return {
        dashboardId: dashboard?.id,
        dashboardTitle: dashboard?.title
    }
}

module.exports = {
    account_upgrade_request: { // clicking on switch to live button in dashboard editor
        excludeSuperAdmin: true,
        getProps: getDefaultAccountDashboardProps
    }
}